import { Equal } from 'lucide-react';
import { DeckardIconWrapper } from './DeckardIcon';

export const EqualIcon = DeckardIconWrapper({ Icon: Equal });
